/*
 * @Author: yzf
 * @Date: 2020-07-01 21:34:14
 * @LastEditTime: 2021-01-07 10:20:14
 * @LastEditors: yzf
 * @Description: 这是 文件
 * @FilePath: /alex/Volumes/project/hex/wuwei-editor/src/vuex/actions/project_actions.js
 * @大威天龙,世尊地藏,般若诸佛,般若巴麻空,没有bug
 */
import { getTables } from '../../apis/table_apis'
import {
  getOssTemplates
} from '../../apis/oss_apis'

export const selectProject = ({ dispatch }, project) => {
  dispatch('SELECT_PROJECT', project);
};

export const initTables = (store, project_id) => {
  let { dispatch, state } = store;
  getTables(project_id).then(res => {
    dispatch('INIT_TABLES', res.data.data);
  });
};

export const initOsses = (store, project_id) => {
  let { dispatch, state } = store;
  getOssTemplates(project_id).then(res => {
    dispatch('INIT_OSSES', res.data.data);
  });
}

export const updateTablesCache = ({ dispatch }, tableID, table = null) => {
  dispatch('UPDATE_TABLES_CACHE', tableID, table);
};

export const updateOssesCache = ({ dispatch }, uuid, oss = null) => {
  dispatch('UPDATE_OSSES_CACHE', uuid, oss);
};

export const initI18ns = ({ dispatch }, i18ns) => {
  dispatch('INIT_I18N', i18ns);
};

export const addI18n = ({ dispatch }, item) => {
  dispatch('ADD_I18N', item);
};

export const updateI18n = ({ dispatch }, i18nItem) => {
  dispatch('UPDATE_I18N', i18nItem);
};
export const initProjectInfo = ({ dispatch }, project) => {
  // console.log('project', project);
  dispatch('INIT_PROJECT_INFO', project);
};
export const changeDeployStatus = ({ dispatch }, status) => {
  dispatch('CHANGE_DEPLOY_STATUS', status);
};

export const changeProjectOssTemplates = ({ dispatch }, templates) => {
  dispatch('CHANGE_PROJECT_SMS_TEMPLATES', templates);
};

export const recordControlActions = ({ dispatch }, templates) => {

};



// WEBPACK FOOTER //
// ./src/vuex/actions/project_actions.js